import React from 'react';

class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'oc'
  }
  render() {
    const {
      prefixCls,
    } = this.props;

    return (
      <div className={`${prefixCls}`}>
        <div className={`${prefixCls}-con`}>
          <h2>业务组件介绍</h2>
          <p>1、人员选择按钮（支持多选）</p>
          <p>2、部门选择按钮（支持多选）</p>
          <p>3、分部选择按钮（支持多选）</p>
          <p>4、流程类型选择按钮（支持多选）</p>
          <p>5、流程按钮（支持多选）</p>
          <p>6、节点选择按钮（支持多选）</p>
          <p>7、自定义选择按钮（支持多选）</p>
          <p>8、我的请求按钮（支持多选）</p>
          <p>...</p>
        </div>
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/oc/componentDoc/Business.js